import React, { Component } from 'react';
import PropTypes from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col
} from 'react-bootstrap';
import TableList from '../../components/TableList';
import { ContextMenu } from 'components/context-menu/context-menu';
import { MessengerBox } from 'components/messenger-box/messenger-box';
import { CheckBox } from 'components/checkboxes/check-box';
import { Popup } from 'components/Popup/popup';
import { AppSettings } from '../../constants';
import * as UnitHelper from 'helper/unit-helper';
import * as ItemRepairActionType from '../constants';
import { AddProblemModal } from '../Components/add-problem-modal';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';

const defaultParams = {
  defaultSortName: 'name',
  defaultSortOrder: 'ascending',
  sizePerPage: 10
};

class ManageProblems extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    location: PropTypes.object,
    ManageItemRepair: PropTypes.object,
    ManageProblem: PropTypes.object,
    match: PropTypes.object,
    history: PropTypes.object,
    ProblemProfile: PropTypes.object,
    ItemRepairProfile: PropTypes.object,
    SelectListItemTrades: PropTypes.object,
    ItemRepairList: PropTypes.object,
    ErrorMsg: PropTypes.object,
    isOpenFormAddEdit: PropTypes.bool,
    isCreate: PropTypes.bool,
    title: PropTypes.string,
    IsCreate: PropTypes.bool,
    Title: PropTypes.string,
    IsOpenFormAddEdit: PropTypes.bool
  }
  constructor(props) {
    super(props);
    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      currentPage: props.ManageProblem.params.skip,
      sizePerPage: props.ManageProblem.params.take,
      totalRecord: props.ManageProblem.params.totalRecord,
      data: props.ManageProblem.items,
      status: props.ManageProblem.params.status,

      itemId: this.props.match.params.itemId ? this.props.match.params.itemId : '',

      isOpenModal: false,
      isShowPopup: false,
      checkedValues: ['active', 'inActive']
    };
  }

  componentDidMount() {
    this.binding(this.objToParams(this.props.ManageProblem.params));
    this.onBindingItem();

    const self = this;
    window.addEventListener('click', (e) => {
      if (document.getElementById('s1-popup') && document.getElementById('s1-popup').contains(e.target)) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (document.getElementById('popup-button') && document.getElementById('popup-button').contains(e.target)) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({isShowPopup: false});
          }
        }

      }
    });
  }

  componentWillReceiveProps(nextProps) {
    // this.setState({
    //   isOpenModal: nextProps.IsOpenFormAddEdit
    // });

    const { ManageProblem } = nextProps;
    if (ManageProblem) {
      this.setState({
        totalRecord: ManageProblem.params.totalRecord,
        data: ManageProblem.items,
        status: ManageProblem.params.status,
        currentPage: ManageProblem.params.skip
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatch({ type: ItemRepairActionType.RESET_PROBLEM });
  }

  customRenderName(item) {
    var style = {};

    if (!item.status) {
      style = { opacity: 0.5 };
    }

    return <span style={style}>{item.name}</span>;
  }

  customRenderBtnAction(item) {
    return <a className='glyphicon glyphicon-option-vertical cls-table-black-icon' onClick={(e) => { this.onContextMenu(e, item); }} />;
  }

  binding(params) {
    this.props.dispatch({
      type: ItemRepairActionType.SEARCH_PROBLEM_ASYNC,
      params: {...params, itemRepairId: this.state.itemId}
    });
  }

  onContextMenu(e, item) {

    var contextItem = [];

    if (item.status) {
      contextItem = [
        {
          title: 'Edit',
          icon: 'glyphicon glyphicon-pencil',
          event: this.onOpenAddEditPopup.bind(this)
        },
        {
          title: 'Make inactive',
          icon: 'glyphicon glyphicon-minus-sign',
          event: this.onMakeInActive.bind(this)
        }
      ];
    } else {
      contextItem = [
        {
          title: 'Edit',
          icon: 'glyphicon glyphicon-pencil',
          event: this.onOpenAddEditPopup.bind(this)
        },
        {
          title: 'Make active',
          icon: 'glyphicon glyphicon-ok-sign',
          event: this.onMakeActive.bind(this)
        }
      ];
    }

    this.cxtMenu.state.event(e, item, contextItem);

  }

  onMakeInActive(e, item) {
    this.onSaveItem(e, {id: item.id}, ItemRepairActionType.MAKE_INACTIVE_PROBLEM_ASYNC);
  }

  onMakeActive(e, item) {
    this.onSaveItem(e, {id: item.id}, ItemRepairActionType.MAKE_ACTIVE_PROBLEM_ASYNC);
  }

  // onTableBinding(configTable) {
  //   var params = this.objToParams(this.props.ManageProblem.params);
  //   this.binding({
  //     ...params,
  //     sortField: configTable.sort.field,
  //     sortOrder: configTable.sort.order,
  //     skip: configTable.page.skip - 1,
  //     take: configTable.page.take
  //   });
  // }

  onSaveItem(e, data, itemRepairActionType) {
    var params = {
      ...this.objToParams(this.props.ManageProblem.params),
      itemRepairId: this.props.location.state.itemToRepair.id
    };
    const requestData = {
      name: data.name,
      itemRepairId: this.props.location.state.itemToRepair.id,
      id: data.id
    };
    this.props.dispatch({
      type: itemRepairActionType,
      params: {
        id: this.state.itemId,
        data: requestData,
        search: params
      },
      callback: () => { this.setState({isOpenModal: false}); }
    });
  }

  onOpenAddEditPopup(e, item) {
    if (typeof (item) === 'undefined') {
      this.props.dispatch({
        type: ItemRepairActionType.OPEN_FORM_CREATE_PROBLEM,
        params: null
      });
    } else {
      this.props.dispatch({
        type: ItemRepairActionType.GET_PROBLEM_BY_ID_ASYNC,
        params: item.id
      });
    }
    this.setState({isOpenModal: true, itemEdit: item});
  }

  closeModal = (e) => {
    e.preventDefault();
    this.setState({isOpenModal: false});
    // this.props.dispatch({
    //   type: ItemRepairActionType.CLOSE_FORM_CREATE_PROBLEM,
    //   params: null
    // });
  }

  handleChange = (e, value) => {
    if (this.state.checkedValues.includes(value)) {
      this.setState({
        checkedValues: [...this.state.checkedValues.filter(item => item !== value).sort()]
      }, () => {
        this.onChecked(e, this.state.checkedValues);
      });
    } else {
      this.setState({
        checkedValues: [...this.state.checkedValues, value].sort()
      }, () => {
        this.onChecked(e, this.state.checkedValues);
      });
    }
  }

  onTogglePopupFilter = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup
    });
  }

  onChecked(e, data) {
    const newData = data.map(item => {
      if (item === 'active') {
        return 1;
      } else {
        return 0;
      }
    });
    var status = UnitHelper.isEmpty(newData.toString()) ? '' : newData.toString();
    if (status !== '') {
      var params = this.objToParams(this.props.ManageProblem.params);
      if (status.includes(0, 1)) {
        status = 'all';
      }
      this.binding({
        ...params,
        status: status,
        skip: 0
      });
    } else {
      this.setState({ data: [] });
    }
  }

  onBindingItem() {
    this.props.dispatch({
      type: ItemRepairActionType.SELECT_LIST_ITEM_REPAIR_ASYNC,
      params: {searchKey: '', selectedValue: '', setDefaultSelected: false }
    });
  }

  objToParams(obj) {
    return {
      value: '',//value,
      searchField: 'name',//searchField,
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      status: obj.status,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  refreshList(params) {
    this.setState({
      defaultSortName: params.defaultSortName,
      defaultSortOrder: params.defaultSortOrder,
      sizePerPage: params.sizePerPage
    }, () => {
      this.props.dispatch({
        type: ItemRepairActionType.SEARCH_PROBLEM_ASYNC,
        params: {
          searchKey: '',//this.searchBox.state.value,
          sortField: params.defaultSortName,
          sortOrder: params.defaultSortOrder,
          status: this.state.status,
          skip: params.currentPage - 1,
          take: params.sizePerPage,
          itemRepairId: this.state.itemId
        }
      });
    });
  }

  render() {
    const column = [
      { field: 'id', header: 'id', hidden: true, isKey: true, sort: false, dataAlign: 'left', headerAlign: 'left' },
      {
        field: 'name', header: 'Name', hidden: false, isKey: false, sort: true, dataAlign: 'left', headerAlign: 'left',
        customRender: this.customRenderName.bind(this)
      },
      {
        field: '', header: '', hidden: false, isKey: false, sort: false, dataAlign: 'right', headerAlign: 'right',
        customRender: this.customRenderBtnAction.bind(this), className: 'column-action', columnClassName: 'column-action'
      }
    ];

    const { data } = this.state;

    const totalRecord = data.length > 0 ? this.state.totalRecord : 0;

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: totalRecord
    };

    const customHeader = (
      <div className='table-header'>
        <Row>
          <Col sm={12} md={12} className='text-right'>
            <div className='manage-user-filter pull-right'>
              <button
                onClick={this.onTogglePopupFilter}
                className='btn btn-secondary fa fa-filter btn-icon'
                id='popup-button'
                style={{ paddingTop: 10, paddingBottom: 10, marginLeft: 10 }}/>

              {this.state.isShowPopup &&
                <Popup ref={(ref) => { this.popup = ref; }}>
                  <CheckBox
                    checked={this.state.checkedValues.includes('active')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='active'
                    label='Active'
                    handleChange={this.handleChange} />
                  <CheckBox
                    checked={this.state.checkedValues.includes('inActive')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='inActive'
                    label='InActive'
                    handleChange={this.handleChange} />
                </Popup>
              }
            </div>
          </Col>
        </Row>
      </div>
    );

    return <div id='manage-user'>
      <div className='page-title clearfix'>
        <h2 className='pull-left'>Problems ({totalRecord})</h2>
        <button
          className='btn btn-primary btn-info btn-siteone pull-right btn-icon'
          onClick={this.onOpenAddEditPopup.bind(this)}>
          <span className='fa fa-plus icon' />NEW</button>
      </div>
      <Breadcrumb breadcrumbs={[
        {title: 'Items to repair', url: '/manage-items'},
        {title: this.props.location.state.itemToRepair.description, url: ''},
        {title: 'Problems', url: ''}
      ]} />
      {/*<ul className='breadcrumb'>
        <li><Link to={'/manage-items'}>Items to repair</Link></li>
        <li className='breadcrumb-siteone-li'>{this.props.location.state.itemToRepair.description}</li>
        <li className='breadcrumb-siteone-li'>Problems</li>
    </ul>*/}
      {
        this.state.isOpenModal &&
        <AddProblemModal
          isOpen={this.state.isOpenModal}
          problem={this.state.itemEdit}
          item={this.props.location.state.itemToRepair}
          errorMsg={this.props.ErrorMsg}
          isCreate={this.props.IsCreate}
          title={this.props.Title}
          closeModal={this.closeModal}
          onSubmit={this.onSaveItem.bind(this)} />
      }
      <TableList
        column={column}
        defaultParams={defaultParams}
        data={data}
        ignoreSinglePage={true}
        options={options}
        refreshPageList={this.refreshList.bind(this)}
        refreshList={this.refreshList.bind(this)}
        showButtonMenu={true}
        onContextMenu={this.onContextMenu.bind(this)}
        customTableHeader={customHeader}/>

      <ContextMenu ref={(ref) => { this.cxtMenu = ref; }} />
      <MessengerBox ref={(ref) => { this.msgBox = ref; }} title={AppSettings.LOGO_30} />
    </div>;
  }
}

const mapStateToProps = (state) => {
  return state.ItemRepairStore;
};

export default connect(mapStateToProps)(ManageProblems);



// WEBPACK FOOTER //
// ./src/Items/Containers/manage-problem.js